module.exports = __webpack_public_path__ + "img/Icon - Done or Correct.f19c7d0b.svg";